export default function CoverImageUpload({ coverImages, setCoverImages }) {
  const MAX_IMAGES = 8;

  const handleImageChange = (index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    const updatedImages = [...coverImages];
    updatedImages[index] = {
      file,
      preview: URL.createObjectURL(file),
    };
    setCoverImages(updatedImages);
  };

  const removeImage = (index) => {
    const updatedImages = [...coverImages];
    updatedImages[index] = null;
    setCoverImages(updatedImages);
  };

  return (
    <div className="col-md-12">
      <label className="form-label">Cover Images(s)</label>
      <div className="cover-images">
        {Array.from({ length: MAX_IMAGES }).map((_, index) => {
          const img = coverImages[index];
          return (
            <div className="input-file" key={index}>
              {img ? (
                <>
                  <img
                    src={img.preview}
                    alt={`Cover ${index + 1}`}
                    className="img-fluid"
                  />
                  <button
                    type="button"
                    className="close-btn"
                    onClick={() => removeImage(index)}
                  >
                    ×
                  </button>
                </>
              ) : (
                <>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => handleImageChange(index, e)}
                  />
                  <span className="upload-icon"></span>
                </>
              )}
            </div>
          );
        })}
      </div>
      <p>
        <small className="light-text">Up to 8 cover images.</small>
      </p>
    </div>
  );
}
